module.exports = __webpack_public_path__ + "static/media/image_51.143b415a.png";